import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import {
  getTotalFromCart,
  selectCartItem,
  selectCartState,
  selectTotalAmount,
  selectTotalQuantity,
  setClearCartItems,
  setCloseCart,
} from '../app/CartSlice';

import CartCount from './Utlis/cart/CartCount';
import CartEmpty from './Utlis/cart/CartEmpty';
import CartItem from './Utlis/cart/CartItem';

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const ifCartState = useSelector(selectCartState);

  const cartItem = useSelector(selectCartItem);

  const totalAmount = useSelector(selectTotalAmount);

  const totalQty = useSelector(selectTotalQuantity);

  const isCartOpen = () => {
    dispatch(
      setCloseCart({
        cartState: false,
      })
    );
  };

  useEffect(() => {
    dispatch(getTotalFromCart());
  }, [cartItem, dispatch]);

  const clearCart = () => {
    dispatch(setClearCartItems());
  };
  return (
    <>
      <div
        className={`fixed top-0 left-0 right-0 bottom-0 w-full h-full blur-effect-theme opacity-100 z-[250] transition-smooth
         ${
           ifCartState
             ? 'opacity-100 visible translate-x-0'
             : 'opacity-0  invisible translate-x-8'
         }`}
      >
        <div className='blur-effect-theme  max-w-lg w-full h-full  absolute top-0 right-0 bottom-0 opacity-100 z-[300] '>
          {' '}
          <CartCount
            isCartOpen={isCartOpen}
            clearCart={clearCart}
            totalQty={totalQty}
          />
          {cartItem?.length === 0 ? (
            <CartEmpty isCartOpen={isCartOpen} />
          ) : (
            <div>
              {cartItem.map((item, index) => {
                return <CartItem key={index} item={item} />;
              })}
            </div>
          )}
          <div className='fixed bottom-0 bg-white w-full px-5 py-2 grid items-center'>
            <div className='flex items-center justify-between'>
              <h1 className='text-base font-semibold uppercase'>SubTotal</h1>
              <h1 className='text-sm rounded bg-theme-cart text-slate-100 px-1 py-0.5'>
                {totalAmount}
              </h1>
            </div>
            <div className='grid items-center gap-2'>
              <p className='text-sm font-medium text-center'>
                Taxes and Shipping Will Calculate At Shipping
              </p>
              <button
                type='button'
                className='button-theme bg-theme-cart text-white'
                onClick={() => {
                  navigate('/addingDetails');
                }}
              >
                Check Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cart;
